module.exports = __webpack_public_path__ + "img/TBPSYSCS4.f9c32a33.jpg";